import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AlertComponent } from './_directives/alert.component';
import { UserAuthModule } from './user/auth.module';
import { PublisherUserAuthModule } from './publisher-user/auth.module';

@NgModule({
    declarations: [AlertComponent],
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        UserAuthModule,
        PublisherUserAuthModule
    ],
    providers: [],
    exports: [UserAuthModule, PublisherUserAuthModule],
    entryComponents: [AlertComponent]
})
export class AuthSharedModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/auth.shared.module.ts